import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAOuXcOlDZcYpU3BvzUcNuTYgi_o0GhJrk",
  authDomain: "evala-fe013.firebaseapp.com",
  projectId: "evala-fe013",
  storageBucket: "evala-fe013.appspot.com",
  messagingSenderId: "126986556303",
  appId: "1:126986556303:web:7665ea64345c678efab1fa",
  measurementId: "G-X0T7M0MVC7"
};

const firebase = initializeApp(firebaseConfig);

const db = getFirestore(firebase);
const users = collection(db, 'adventurers');

export default users;